import { Dispatch, Action } from 'redux'
import { UpdateWorkspaceLogoMainMapDispatchReturnType } from './types/UpdateWorkspaceLogoMainMapDispatchReturnType'

export const UpdateWorkspaceLogoMainMapDispatch = (
  _dispatch: Dispatch<Action>
): UpdateWorkspaceLogoMainMapDispatchReturnType => {
  return {}
}
